var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _ellipse, _ellipse2, _path46, _ellipse3, _ellipse4, _path47, _ellipse5, _ellipse6, _path48, _ellipse7, _ellipse8, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _ellipse9, _ellipse10, _ellipse11, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g, _path112, _path113, _path114, _path115, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _path116, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 735,
    height: 537,
    viewBox: "0 0 735 537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.698 443.5L186.5 470.446L233.3 443.501L186.498 416.554L139.698 443.5ZM186.5 472L137 443.5L186.498 415L236 443.501L186.5 472Z",
    fill: "#D4D1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.048 409L500.499 388.441C501.118 388.082 501.882 388.081 502.502 388.439L537.134 408.422C537.754 408.78 538.517 408.779 539.136 408.421L693.147 319.23C694.478 318.46 694.478 316.54 693.148 315.769L636.756 283.097",
    stroke: "#D4D1FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244 363.193L210.489 382.516C209.876 382.87 209.122 382.873 208.506 382.525L16.0411 273.719C14.6952 272.958 14.6848 271.023 16.0223 270.248L120.5 209.681",
    stroke: "#D4D1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M576.698 440.5L623.5 467.446L670.3 440.501L623.498 413.554L576.698 440.5ZM623.5 469L574 440.5L623.498 412L673 440.501L623.5 469Z",
    fill: "#D4D1FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.698 124.5L289.5 151.446L336.3 124.501L289.498 97.5536L242.698 124.5ZM289.5 153L240 124.5L289.498 96L339 124.501L289.5 153Z",
    fill: "#D4D1FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M446.25 473.015L507.998 437.491C509.333 436.724 509.336 434.8 508.004 434.028L420 383",
    stroke: "#D4D1FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85 188.768C85 189.764 85.664 190.179 86.411 190.594L154.057 229.688C155.053 230.269 155.833 230.518 156.962 230.518C158.091 230.518 159.12 230.186 160.033 229.688L227.845 190.511C228.592 190.096 229.09 189.515 229.09 188.602C229.09 187.855 228.709 187.39 227.845 186.859L192.155 166.192L191.408 167.105L227.264 187.855C227.679 188.104 228.011 188.27 228.011 188.602C228.011 189.1 227.663 189.333 227.264 189.598L160.033 228.443L159.998 228.462C159.097 228.954 158.208 229.439 156.962 229.439C155.701 229.439 154.937 228.908 154.14 228.443L86.411 189.349C86.162 189.183 86.079 188.967 86.079 188.768C86.079 188.569 86.1454 188.303 86.411 188.104L121.853 167.603V166.192L86.411 186.776C85.2822 187.44 85 188.021 85 188.768Z",
    fill: "#D4D1FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106 188.768C106 189.167 106.332 189.432 106.747 189.681L155.136 217.57C155.717 217.902 156.215 218.234 156.962 218.234C157.709 218.234 158.191 218.167 159.12 217.57L207.261 189.681C207.759 189.349 208.091 189.1 208.091 188.685C208.091 188.27 207.66 187.955 207.261 187.689L182.942 173.496H131.315L106.747 187.689C106.215 188.021 106 188.37 106 188.768Z",
    fill: "#2112BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.078 161.544C106.347 161.146 105.916 160.797 105.916 160.382C105.916 159.918 106.497 159.469 107.244 159.054L156.961 129.506L207.675 159.552C208.074 159.818 208.173 160.05 208.173 160.299C208.173 160.714 207.924 160.963 207.675 161.129L158.787 189.35C157.991 189.815 157.542 189.848 156.961 189.848C156.38 189.848 155.716 189.599 155.301 189.35L107.078 161.544Z",
    fill: "url(#paint0_linear_1049_5707)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.078 161.545C106.347 161.146 105.916 160.798 105.916 160.383V169.679C105.916 170.177 106.214 170.542 107.078 171.007L155.301 198.812C155.882 199.144 156.43 199.31 156.961 199.31C157.493 199.31 158.256 199.144 158.787 198.812L207.675 170.592C207.924 170.426 208.173 169.978 208.173 169.513V160.3C208.173 160.715 207.924 160.964 207.675 161.13L158.787 189.35C157.991 189.815 157.542 189.848 156.961 189.848C156.38 189.848 155.716 189.599 155.301 189.35L107.078 161.545Z",
    fill: "url(#paint1_linear_1049_5707)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.639 159.386L119.196 155.485L156.962 133.573L201.119 159.137C201.866 159.552 202.364 159.801 202.364 160.216C202.364 160.714 201.866 161.129 201.119 161.544L158.788 185.947C158.124 186.279 157.709 186.528 157.045 186.528C156.381 186.528 155.8 186.279 155.219 185.947L112.639 161.378C112.174 161.113 111.726 160.781 111.726 160.382C111.726 159.984 112.058 159.718 112.639 159.386Z",
    fill: "#5445ED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.377 160.382C115.377 160.05 115.792 159.635 116.207 159.386L155.384 136.893H158.787L197.964 159.469C198.893 160.067 198.711 160.714 197.964 161.212L158.787 183.872C158.123 184.27 157.542 184.37 156.961 184.37C156.38 184.37 155.965 184.204 155.384 183.872L116.207 161.212C115.743 160.947 115.377 160.714 115.377 160.382Z",
    fill: "#7367F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.916 148.845V139.466C105.916 139.881 106.248 140.13 106.497 140.296L155.384 168.517C156.38 169.098 157.924 169.048 158.787 168.517C167.752 163 208.173 140.412 208.173 139.217V148.845C208.173 149.26 207.841 149.592 207.26 149.924L158.787 177.896C157.874 178.477 156.214 178.394 155.384 177.896L106.912 149.924C106.38 149.592 105.916 149.26 105.916 148.845Z",
    fill: "url(#paint2_linear_1049_5707)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.886 110.581C155.55 110.166 156.214 110 157.127 110C157.957 110 158.521 110.249 159.119 110.581L207.26 138.386C207.675 138.635 208.007 138.967 208.007 139.299C208.007 139.631 207.857 139.98 207.26 140.378L159.119 168.267C158.455 168.599 157.708 168.931 156.961 168.931C156.263 168.931 155.841 168.699 155.193 168.344C155.147 168.319 155.1 168.293 155.052 168.267L106.496 140.295C106.081 140.046 105.915 139.797 105.915 139.465C105.915 139.216 106.098 138.851 106.828 138.386L154.886 110.581ZM112.581 140.379C112.187 140.149 111.725 139.88 111.725 139.465C111.725 139.05 111.991 138.851 112.721 138.386L155.384 113.735C155.965 113.403 156.529 113.154 157.127 113.154C157.56 113.154 157.93 113.342 158.456 113.61C158.535 113.65 158.617 113.692 158.704 113.735L201.533 138.386C202.031 138.635 202.363 138.967 202.363 139.299C202.363 139.797 202.064 140.046 201.533 140.378L158.704 165.113C158.289 165.362 157.575 165.611 157.044 165.611C156.463 165.611 155.965 165.611 155.301 165.113L112.721 140.461C112.676 140.434 112.629 140.407 112.581 140.379Z",
    fill: "url(#paint3_linear_1049_5707)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.581 140.379C112.187 140.149 111.725 139.88 111.725 139.465C111.725 139.05 111.991 138.851 112.721 138.386L155.384 113.735C155.965 113.403 156.529 113.154 157.127 113.154C157.56 113.154 157.93 113.342 158.456 113.61C158.535 113.65 158.617 113.692 158.704 113.735L201.533 138.386C202.031 138.635 202.363 138.967 202.363 139.299C202.363 139.797 202.064 140.046 201.533 140.378L158.704 165.113C158.289 165.362 157.575 165.611 157.044 165.611C156.463 165.611 155.965 165.611 155.301 165.113L112.721 140.461C112.676 140.434 112.629 140.407 112.581 140.379ZM115.986 140.194C115.688 139.978 115.378 139.753 115.378 139.466C115.378 139.217 115.527 138.951 116.125 138.553L155.633 115.727C156.048 115.478 156.53 115.312 157.127 115.312C157.625 115.312 157.858 115.395 158.455 115.727L198.13 138.636C198.545 138.885 198.711 139.051 198.711 139.383C198.711 139.632 198.528 139.947 198.13 140.213L158.538 163.038C158.04 163.287 157.625 163.453 156.961 163.453C156.463 163.453 156.148 163.37 155.55 163.038L116.125 140.296C116.08 140.262 116.033 140.228 115.986 140.194Z",
    fill: "#5445ED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.377 139.465C115.377 139.797 115.792 140.046 116.124 140.295L155.55 163.038C156.148 163.37 156.463 163.453 156.961 163.453C157.625 163.453 158.04 163.287 158.538 163.038L198.13 140.212C198.528 139.947 198.711 139.631 198.711 139.382C198.711 139.05 198.545 138.884 198.13 138.635L158.455 115.727C157.858 115.395 157.625 115.312 157.127 115.312C156.53 115.312 156.048 115.478 155.633 115.727L116.124 138.552C115.527 138.951 115.377 139.216 115.377 139.465Z",
    fill: "#7367F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.299 132.893L152.445 131.418L159.12 127.537C159.493 127.32 159.78 127.46 159.935 127.731L165.679 138.598L162.923 138.209L162.07 137.627L158.655 131.224C158.46 130.836 157.995 130.681 157.607 130.914L153.959 133.048C153.71 133.203 153.416 133.087 153.299 132.893Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.752 134.135L154.695 135.299L157.683 140.693L167.541 142.246L166.959 140.849L166.221 140.422L160.555 139.568L159.857 139.141L157.567 134.445C157.381 134.042 157.024 133.98 156.752 134.135Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.37 136.269L142.665 139.607L168.123 144.147L169.016 144.613L169.598 146.087L137.349 140.577C137.069 140.515 137.077 140.344 137.232 140.266L149.612 133.048C150.14 132.769 150.466 132.893 150.621 133.203L154.502 140.15L148.642 139.025C148.518 138.993 148.487 138.908 148.564 138.869L150.233 137.899L149.651 136.541C149.558 136.323 149.302 136.114 148.991 136.114C148.758 136.114 148.564 136.153 148.37 136.269Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.917 160.368C105.929 159.908 106.506 159.465 107.245 159.054L114.879 154.518L107.079 150.007C106.615 149.742 105.917 149.343 105.917 149.011V160.368ZM199.274 154.574L207.677 159.552C208.075 159.818 208.175 160.05 208.175 160.299C208.175 160.714 207.926 160.963 207.677 161.129L158.789 189.35C157.992 189.815 157.544 189.848 156.963 189.848C156.784 189.848 156.597 189.824 156.411 189.784C156.597 189.824 156.784 189.848 156.963 189.848C157.544 189.848 157.993 189.815 158.789 189.35L207.677 161.129C207.926 160.963 208.175 160.714 208.175 160.299V148.928C208.175 149.127 207.843 149.592 207.345 149.924L199.274 154.574Z",
    fill: "#7367F0",
    fillOpacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M339 494.359C339 495.375 339.677 495.798 340.44 496.222L409.452 536.105C410.468 536.698 411.264 536.952 412.415 536.952C413.567 536.952 414.617 536.613 415.548 536.105L484.73 496.137C485.492 495.714 486 495.121 486 494.19C486 493.427 485.61 492.953 484.73 492.411L448.319 471.327L447.556 472.258L484.137 493.427C484.56 493.681 484.899 493.851 484.899 494.19C484.899 494.698 484.544 494.935 484.137 495.206L415.548 534.835L415.513 534.854C414.593 535.356 413.686 535.851 412.415 535.851C411.128 535.851 410.349 535.309 409.536 534.835L340.44 494.952C340.185 494.782 340.101 494.562 340.101 494.359C340.101 494.156 340.169 493.885 340.44 493.681L376.597 472.766V471.327L340.44 492.327C339.288 493.004 339 493.597 339 494.359Z",
    fill: "#D4D1FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M360.424 494.359C360.424 494.765 360.763 495.036 361.186 495.29L410.553 523.742C411.146 524.08 411.654 524.419 412.416 524.419C413.178 524.419 413.669 524.351 414.617 523.742L463.73 495.29C464.238 494.951 464.577 494.697 464.577 494.274C464.577 493.851 464.137 493.529 463.73 493.258L438.92 478.778H386.25L361.186 493.258C360.644 493.597 360.424 493.952 360.424 494.359Z",
    fill: "#2112BA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.194 466.926C360.444 466.516 360.001 466.158 360.001 465.732C360.001 465.255 360.598 464.795 361.365 464.369L412.414 434.029L464.487 464.88C464.896 465.153 464.998 465.391 464.998 465.647C464.998 466.073 464.743 466.329 464.487 466.499L414.289 495.476C413.471 495.953 413.011 495.987 412.414 495.987C411.818 495.987 411.136 495.732 410.71 495.476L361.194 466.926Z",
    fill: "url(#paint4_linear_1049_5707)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M361.194 466.926C360.444 466.517 360.001 466.159 360.001 465.732V475.278C360.001 475.789 360.308 476.164 361.194 476.641L410.71 505.192C411.307 505.533 411.869 505.703 412.414 505.703C412.96 505.703 413.744 505.533 414.289 505.192L464.487 476.215C464.743 476.045 464.998 475.584 464.998 475.107V465.647C464.998 466.073 464.743 466.329 464.487 466.499L414.289 495.476C413.471 495.953 413.011 495.987 412.414 495.987C411.818 495.987 411.136 495.732 410.71 495.476L361.194 466.926Z",
    fill: "url(#paint5_linear_1049_5707)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M366.904 464.709L373.637 460.704L412.415 438.204L457.754 464.454C458.521 464.88 459.033 465.136 459.033 465.562C459.033 466.073 458.521 466.499 457.754 466.925L414.29 491.981C413.608 492.322 413.182 492.578 412.5 492.578C411.818 492.578 411.221 492.322 410.625 491.981L366.904 466.755C366.427 466.482 365.967 466.141 365.967 465.732C365.967 465.323 366.308 465.05 366.904 464.709Z",
    fill: "#5445ED"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M369.716 465.733C369.716 465.392 370.142 464.965 370.569 464.71L410.795 441.614H414.289L454.515 464.795C455.47 465.409 455.282 466.073 454.515 466.585L414.289 489.851C413.607 490.26 413.011 490.363 412.414 490.363C411.818 490.363 411.391 490.192 410.795 489.851L370.569 466.585C370.091 466.312 369.716 466.073 369.716 465.733Z",
    fill: "#7367F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M360.001 453.886V444.255C360.001 444.682 360.342 444.937 360.598 445.108L410.795 474.084C411.818 474.681 413.403 474.63 414.289 474.084C423.494 468.42 464.998 445.227 464.998 444V453.886C464.998 454.312 464.658 454.653 464.061 454.994L414.289 483.715C413.352 484.311 411.647 484.226 410.795 483.715L361.024 454.994C360.478 454.653 360.001 454.312 360.001 453.886Z",
    fill: "url(#paint6_linear_1049_5707)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.283 414.597C410.965 414.17 411.646 414 412.584 414C413.436 414 414.016 414.256 414.629 414.597L464.06 443.147C464.486 443.403 464.827 443.744 464.827 444.085C464.827 444.425 464.674 444.783 464.06 445.192L414.629 473.828C413.948 474.169 413.181 474.51 412.414 474.51C411.697 474.51 411.263 474.272 410.598 473.907C410.551 473.882 410.503 473.855 410.453 473.828L360.597 445.107C360.17 444.852 360 444.596 360 444.255C360 443.999 360.187 443.624 360.937 443.147L410.283 414.597ZM366.844 445.193C366.44 444.957 365.966 444.68 365.966 444.255C365.966 443.829 366.238 443.624 366.988 443.147L410.794 417.835C411.391 417.494 411.97 417.238 412.584 417.238C413.029 417.238 413.409 417.432 413.949 417.707C414.03 417.748 414.114 417.791 414.203 417.835L458.179 443.147C458.691 443.403 459.032 443.744 459.032 444.084C459.032 444.596 458.725 444.851 458.179 445.192L414.203 470.589C413.777 470.845 413.044 471.101 412.499 471.101C411.902 471.101 411.391 471.101 410.709 470.589L366.988 445.278C366.942 445.25 366.894 445.222 366.844 445.193Z",
    fill: "url(#paint7_linear_1049_5707)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.844 445.193C366.44 444.957 365.966 444.68 365.966 444.255C365.966 443.829 366.239 443.624 366.989 443.147L410.794 417.835C411.391 417.494 411.97 417.239 412.584 417.239C413.029 417.239 413.409 417.432 413.949 417.707C414.03 417.748 414.114 417.791 414.203 417.835L458.18 443.147C458.691 443.403 459.032 443.744 459.032 444.084C459.032 444.596 458.725 444.852 458.18 445.192L414.203 470.59C413.777 470.845 413.044 471.101 412.499 471.101C411.902 471.101 411.391 471.101 410.709 470.59L366.989 445.278C366.942 445.25 366.894 445.222 366.844 445.193ZM370.341 445.003C370.035 444.781 369.716 444.55 369.716 444.255C369.716 444 369.87 443.727 370.483 443.318L411.05 419.881C411.477 419.625 411.971 419.455 412.584 419.455C413.096 419.455 413.334 419.54 413.948 419.881L454.686 443.403C455.112 443.659 455.282 443.829 455.282 444.17C455.282 444.426 455.095 444.749 454.686 445.022L414.033 468.459C413.522 468.715 413.096 468.885 412.414 468.885C411.903 468.885 411.579 468.8 410.965 468.459L370.483 445.107C370.437 445.073 370.389 445.038 370.341 445.003Z",
    fill: "#5445ED"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M369.716 444.255C369.716 444.596 370.142 444.851 370.483 445.107L410.965 468.459C411.579 468.8 411.903 468.885 412.414 468.885C413.096 468.885 413.522 468.715 414.033 468.459L454.686 445.022C455.095 444.749 455.282 444.425 455.282 444.17C455.282 443.829 455.112 443.658 454.686 443.403L413.948 419.88C413.335 419.54 413.096 419.454 412.585 419.454C411.971 419.454 411.477 419.625 411.051 419.88L370.483 443.317C369.87 443.726 369.716 443.999 369.716 444.255Z",
    fill: "#7367F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M408.654 437.506L407.777 435.992L414.631 432.007C415.014 431.784 415.309 431.928 415.468 432.206L421.365 443.364L418.536 442.965L417.659 442.368L414.153 435.793C413.954 435.394 413.476 435.235 413.077 435.474L409.331 437.666C409.076 437.825 408.774 437.705 408.654 437.506Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M412.199 438.782L410.087 439.977L413.156 445.516L423.277 447.11L422.679 445.675L421.922 445.237L416.104 444.36L415.387 443.922L413.036 439.1C412.845 438.686 412.478 438.622 412.199 438.782Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M403.593 440.973L397.735 444.4L423.875 449.062L424.792 449.54L425.389 451.054L392.276 445.396C391.989 445.332 391.997 445.157 392.157 445.077L404.868 437.665C405.41 437.379 405.745 437.506 405.904 437.825L409.889 444.958L403.872 443.802C403.744 443.77 403.712 443.683 403.792 443.643L405.506 442.647L404.908 441.252C404.812 441.029 404.549 440.814 404.23 440.814C403.991 440.814 403.792 440.853 403.593 440.973Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.002 465.717C360.015 465.245 360.607 464.79 361.366 464.369L369.204 459.71L361.196 455.079C360.718 454.806 360.002 454.397 360.002 454.056V465.717ZM455.86 459.768L464.488 464.88C464.897 465.153 465 465.391 465 465.647C465 466.073 464.744 466.329 464.488 466.499L414.291 495.476C413.473 495.953 413.012 495.987 412.416 495.987C412.224 495.987 412.022 495.961 411.824 495.916C412.023 495.961 412.224 495.987 412.416 495.987C413.013 495.987 413.473 495.953 414.291 495.476L464.489 466.499C464.744 466.329 465 466.073 465 465.647V453.971C465 454.176 464.659 454.653 464.148 454.994L455.86 459.768Z",
    fill: "#7367F0",
    fillOpacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M485.534 249.443L514.614 232.637L515.939 233.056L485.534 250.699C485.088 251.033 484.976 251.368 484.976 251.814C484.976 252.261 485.116 252.582 485.464 252.791L583.652 309.555C584.837 310.253 585.8 310.392 586.86 310.392C587.92 310.392 589.231 310.113 590.207 309.555L688.255 252.86C688.702 252.582 688.883 252.093 688.883 251.605C688.883 251.117 688.604 250.838 688.255 250.629L657.572 232.846L658.478 232.219L688.255 249.374C689.371 250.043 689.859 250.559 689.859 251.605C689.859 252.651 689.092 253.628 688.255 254.116L590.207 310.671C589.426 311.117 588.143 311.369 586.86 311.369C585.577 311.369 584.349 311.09 583.652 310.671L485.116 253.767C484.446 253.376 484 252.721 484 251.884C484 250.768 484.767 249.862 485.534 249.443Z",
    fill: "#D4D1FA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M509.871 250.141L527.654 239.82L645.995 239.68L663.987 250.141C664.879 250.643 665.242 250.908 665.242 251.605C665.242 252.442 664.614 252.93 663.987 253.279L589.719 296.236C588.77 296.794 587.975 297.003 586.929 297.003C585.758 297.003 584.977 296.654 584.279 296.236L509.802 253.279C509.132 252.888 508.616 252.442 508.616 251.814C508.616 250.978 509.244 250.489 509.871 250.141Z",
    fill: "#2112BA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M509.663 215.343C509.049 215.008 508.547 214.715 508.547 213.948V228.104C508.547 228.871 508.84 229.415 509.732 229.917L583.582 272.526C584.628 273.153 585.465 273.641 586.79 273.641C588.255 273.641 589.273 273.084 590.277 272.526L664.057 229.917C664.824 229.499 665.312 228.774 665.312 228.104V213.878C665.312 214.576 664.754 214.994 664.266 215.273L590.207 258.09C588.924 258.872 588.045 259.067 586.79 259.067C585.465 259.067 584.489 258.648 583.582 258.09L509.663 215.343Z",
    fill: "url(#paint8_linear_1049_5707)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M509.663 212.414L532.606 199.025L635.535 195.817L664.266 212.484C664.936 212.874 665.312 213.251 665.312 213.878C665.312 214.576 664.754 214.994 664.266 215.273L590.207 258.091C588.924 258.872 588.045 259.067 586.79 259.067C585.465 259.067 584.489 258.649 583.582 258.091L509.663 215.343C509.049 215.008 508.547 214.715 508.547 213.948C508.547 213.446 509.035 212.763 509.663 212.414Z",
    fill: "url(#paint9_linear_1049_5707)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M518.798 212.414L537.278 201.745L632.328 199.234L655.48 212.623C656.205 213.014 656.386 213.39 656.386 213.809C656.386 214.367 656.038 214.715 655.48 215.064L589.371 253.279C588.255 253.893 587.739 253.976 586.79 253.976C585.842 253.976 585.117 253.698 584.419 253.279L518.659 215.343C517.933 214.897 517.543 214.576 517.543 213.948C517.543 213.181 518.171 212.763 518.798 212.414Z",
    fill: "#5445ED"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M524.097 212.623L539.718 203.488L632.745 202.791L649.83 212.623C650.388 212.958 650.807 213.321 650.807 213.809C650.807 214.367 650.388 214.785 649.83 215.134L589.021 250.28C588.394 250.629 587.445 250.699 586.72 250.699C585.995 250.699 585.465 250.559 584.976 250.28L524.097 215.134C523.484 214.799 523.121 214.562 523.121 213.948C523.121 213.335 523.609 212.902 524.097 212.623Z",
    fill: "#7367F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M633.164 212.902L625.772 208.578L548.714 208.23L540.834 212.832C540.137 213.251 539.928 213.53 539.928 213.948C539.928 214.436 540.346 214.645 540.834 214.924L584.977 240.448C585.814 240.95 586.455 241.075 587.069 241.075C587.683 241.075 588.254 240.796 588.882 240.448L633.164 214.855C633.722 214.52 633.931 214.157 633.931 213.878C633.931 213.39 633.652 213.181 633.164 212.902Z",
    fill: "#5D4FEE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M525.702 60.2515V195.748L586.93 231.103V95.6074L525.702 60.2515Z",
    fill: "#7A6FF1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M582.745 99.7214L529.886 69.1772V171.898L582.745 140.028V99.7214Z",
    fill: "#948BF4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M529.886 191.075L582.745 221.549V140.028L529.886 171.897V191.075Z",
    fill: "#877DF2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M528.979 65.7603L527.306 66.7366L530.723 72.7339L532.536 71.7576C532.926 71.5344 533.233 70.9905 533.233 70.1537C533.233 67.9919 531.35 65.6208 529.677 65.6208C529.342 65.6208 529.119 65.6906 528.979 65.7603Z",
    fill: "url(#paint10_linear_1049_5707)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.076,
    cy: 69.7544,
    rx: 2.05184,
    ry: 3.48967,
    transform: "rotate(-30.6627 529.076 69.7544)",
    fill: "url(#paint11_linear_1049_5707)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.064,
    cy: 69.7263,
    rx: 1.18509,
    ry: 2.01554,
    transform: "rotate(-30.6627 529.064 69.7263)",
    fill: "#5445ED"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M580.196 97.2808L578.522 98.2571L581.939 104.254L583.753 103.278C584.143 103.055 584.45 102.511 584.45 101.674C584.45 99.5124 582.567 97.1414 580.893 97.1414C580.559 97.1414 580.336 97.2111 580.196 97.2808Z",
    fill: "url(#paint12_linear_1049_5707)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 580.293,
    cy: 101.276,
    rx: 2.05184,
    ry: 3.48967,
    transform: "rotate(-30.6627 580.293 101.276)",
    fill: "url(#paint13_linear_1049_5707)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 580.281,
    cy: 101.247,
    rx: 1.18509,
    ry: 2.01554,
    transform: "rotate(-30.6627 580.281 101.247)",
    fill: "#5445ED"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M580.337 218.62L578.663 219.596L582.08 225.594L583.893 224.617C584.284 224.394 584.591 223.85 584.591 223.014C584.591 220.852 582.708 218.481 581.034 218.481C580.699 218.481 580.476 218.55 580.337 218.62Z",
    fill: "url(#paint14_linear_1049_5707)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 580.432,
    cy: 222.615,
    rx: 2.05184,
    ry: 3.48967,
    transform: "rotate(-30.6627 580.432 222.615)",
    fill: "url(#paint15_linear_1049_5707)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 580.421,
    cy: 222.586,
    rx: 1.18509,
    ry: 2.01554,
    transform: "rotate(-30.6627 580.421 222.586)",
    fill: "#5445ED"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M529.012 187.1L527.338 188.076L530.755 194.073L532.568 193.097C532.959 192.874 533.265 192.33 533.265 191.493C533.265 189.331 531.383 186.96 529.709 186.96C529.374 186.96 529.151 187.03 529.012 187.1Z",
    fill: "url(#paint16_linear_1049_5707)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.107,
    cy: 191.095,
    rx: 2.05184,
    ry: 3.48967,
    transform: "rotate(-30.6627 529.107 191.095)",
    fill: "url(#paint17_linear_1049_5707)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.096,
    cy: 191.066,
    rx: 1.18509,
    ry: 2.01554,
    transform: "rotate(-30.6627 529.096 191.066)",
    fill: "#5445ED"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M586.93 231.103V95.6071L648.088 60.2512V195.817L586.93 231.103Z",
    fill: "url(#paint18_linear_1049_5707)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M596.135 117.574L638.952 92.8877V96.6534L596.135 121.34V117.574Z",
    fill: "#7367F0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M596.135 132.706L638.952 108.02V111.785L596.135 136.472V132.706Z",
    fill: "#7367F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M596.135 147.839L638.952 123.153V126.918L596.135 151.605V147.839Z",
    fill: "#7367F0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M596.135 162.972L638.952 138.285V142.051L596.135 166.737V162.972Z",
    fill: "#7367F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M596.135 178.104L638.952 153.418V157.184L596.135 181.87V178.104Z",
    fill: "#7367F0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M596.135 193.237L638.952 168.55V172.316L596.135 197.002V193.237Z",
    fill: "#7367F0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M525.702 60.251L586.93 24.9648L648.088 60.251L586.93 95.6069L525.702 60.251Z",
    fill: "url(#paint19_linear_1049_5707)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M525.702 60.251L574.951 31.8687H586.93V86.2623H570.747L525.702 60.251Z",
    fill: "url(#paint20_linear_1049_5707)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M586.93 95.6067L525.702 60.2508L526.888 59.5676L586.93 94.3515L647 59.6232L648.088 60.2508L586.93 95.6067Z",
    fill: "#FBFAFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M542.578 57.5312L586.93 83.1242V86.2623L542.578 60.6693V57.5312Z",
    fill: "url(#paint21_linear_1049_5707)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M586.93 83.1242L631.212 57.5312V60.7391L586.93 86.2623V83.1242Z",
    fill: "url(#paint22_linear_1049_5707)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M586.93 31.8687L542.578 57.5313L586.93 83.1242L631.212 57.5313L586.93 31.8687Z",
    fill: "url(#paint23_linear_1049_5707)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M581.63 64.8539L600.04 54.1851L598.158 53.0686L579.678 63.6907L581.63 64.8539Z",
    fill: "#7367F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M598.157 51.5344L578.353 62.9013L579.678 63.6907L598.157 53.0686V51.5344Z",
    fill: "url(#paint24_linear_1049_5707)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M601.365 53.4173L598.157 51.5344V53.0686L600.04 54.1851L601.365 53.4173Z",
    fill: "url(#paint25_linear_1049_5707)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M575.703 61.3671L594.113 50.6983L592.23 49.5818L573.75 60.2038L575.703 61.3671Z",
    fill: "#7367F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M592.23 48.0474L572.425 59.4142L573.75 60.2036L592.23 49.5815V48.0474Z",
    fill: "url(#paint26_linear_1049_5707)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M595.437 49.9305L592.229 48.0476V49.5818L594.112 50.6983L595.437 49.9305Z",
    fill: "url(#paint27_linear_1049_5707)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M569.775 58.0197L588.185 47.3509L586.302 46.2344L567.822 56.8564L569.775 58.0197Z",
    fill: "#7367F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M586.302 44.7L566.497 56.0668L567.822 56.8562L586.302 46.2341V44.7Z",
    fill: "url(#paint28_linear_1049_5707)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M589.51 46.5831L586.302 44.7002V46.2344L588.185 47.3509L589.51 46.5831Z",
    fill: "url(#paint29_linear_1049_5707)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M587.558 68.3405L606.107 57.6013L604.155 56.4158L585.675 67.155L587.558 68.3405Z",
    fill: "#7367F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M607.362 56.8343L604.154 54.9514V56.4159L606.107 57.6014L607.362 56.8343Z",
    fill: "url(#paint30_linear_1049_5707)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M585.675 67.1551L584.35 66.388L604.154 54.9514V56.4159L585.675 67.1551Z",
    fill: "url(#paint31_linear_1049_5707)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M143.194 301.341L159.575 291.767L160.772 292.44L143.568 302.313C143.03 302.672 142.97 303.061 142.97 303.36C142.97 303.839 143.419 304.408 143.868 304.632L346.497 421.841C347.275 422.26 348.666 422.514 349.564 422.514C350.461 422.514 351.359 422.29 352.182 421.841L486.595 344.275C487.193 343.976 487.791 343.452 487.791 342.929C487.791 342.51 487.567 341.956 486.744 341.508L466.549 329.839L467.671 329.166L487.567 340.834C488.405 341.373 488.839 342.256 488.839 342.929C488.839 343.886 488.24 344.5 487.567 344.874L352.705 422.814C351.808 423.352 350.76 423.562 349.564 423.562C348.367 423.562 346.871 423.337 346.048 422.814L143.194 305.455C142.476 304.976 141.923 304.258 141.923 303.36C141.923 302.343 142.446 301.79 143.194 301.341Z",
    fill: "#D4D1FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M157.331 303.136L168.476 296.778L461.013 332.233L473.43 339.563C474.387 340.161 474.776 340.76 474.776 341.358C474.776 342.016 474.103 342.704 473.43 343.078L350.461 414.137C348.965 415.035 348.142 415.259 346.796 415.259C345.3 415.259 344.178 414.735 343.131 414.137L157.331 306.726C155.356 305.53 155.835 303.959 157.331 303.136Z",
    fill: "#2112BA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M153.143 287.279V283.314L343.804 394.39H350.91L477.319 321.162V324.528C477.319 325.067 477.02 325.65 476.497 325.949L350.91 398.504C349.593 399.282 349.04 399.476 347.619 399.476C346.003 399.476 344.926 399.102 343.804 398.504L155.237 289.522C154.04 288.864 153.143 288.101 153.143 287.279Z",
    fill: "#5D4FEE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M343.879 396.634L154.115 286.83C153.517 286.456 153.143 285.663 153.143 285.184V286.287C153.143 286.783 153.576 287.293 154.115 287.652L343.879 397.457C345.076 398.13 345.973 398.429 347.619 398.429C349.04 398.429 349.549 398.235 350.386 397.756L476.347 324.977C476.871 324.678 477.319 324.214 477.319 323.855V322.733C477.319 323.212 476.871 323.855 476.347 324.154L350.386 396.933C349.489 397.457 348.741 397.606 347.619 397.606C346.198 397.606 345.15 397.382 343.879 396.634Z",
    fill: "#877DF2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M154.115 285.11C153.367 284.586 153.143 284.062 153.143 283.539V284.212C153.143 284.661 153.457 285.289 154.115 285.708L344.627 395.811C345.45 396.26 346.587 396.485 347.544 396.485C348.442 396.485 349.399 396.29 350.237 395.811L476.048 323.182C476.721 322.808 477.319 322.135 477.319 321.761V321.162C477.319 321.522 476.871 322.06 476.347 322.359L350.237 395.213C349.399 395.692 348.516 395.886 347.544 395.886C346.347 395.886 345.3 395.587 344.627 395.213L154.115 285.11Z",
    fill: "#877DF2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M154.414 281.744C153.397 282.402 153.143 282.866 153.143 283.464C153.143 284.137 153.651 284.721 154.489 285.259L343.954 394.839C346.347 396.111 348.816 396.186 350.91 394.839L476.272 322.434C477.02 321.985 477.319 321.387 477.319 320.863C477.319 319.891 476.571 319.367 475.375 318.619L286.733 209.414C285.476 208.695 284.564 208.441 283.217 208.441C281.721 208.441 280.524 208.89 279.702 209.414L154.414 281.744Z",
    fill: "url(#paint32_linear_1049_5707)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.997,
    cy: 284.96,
    rx: 1.27158,
    ry: 0.822784,
    fill: "#4333EB"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.69,
    cy: 286.456,
    rx: 1.27158,
    ry: 0.822784,
    fill: "#7367F0"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.383,
    cy: 287.951,
    rx: 1.27158,
    ry: 0.822784,
    fill: "#9086F3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M236.469 266.111C236.469 266.35 236.818 266.609 236.993 266.709L241.705 269.402C242.079 269.626 242.304 269.701 242.678 269.701C243.037 269.701 243.351 269.551 243.65 269.402L248.213 266.784C248.572 266.545 248.736 266.41 248.736 266.186C248.736 265.886 248.587 265.737 248.213 265.512L243.65 262.894C243.291 262.655 242.902 262.595 242.603 262.595C242.244 262.595 241.865 262.684 241.63 262.82C240.209 263.642 237.292 265.333 236.993 265.512C236.619 265.737 236.469 265.812 236.469 266.111Z",
    fill: "#7367F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M245.445 261.024C245.445 261.264 245.794 261.523 245.969 261.623L250.681 264.315C251.055 264.54 251.28 264.615 251.654 264.615C252.013 264.615 252.327 264.465 252.626 264.315L257.189 261.698C257.548 261.458 257.712 261.324 257.712 261.099C257.712 260.8 257.563 260.65 257.189 260.426L252.626 257.808C252.267 257.569 251.878 257.509 251.579 257.509C251.22 257.509 250.841 257.597 250.606 257.733C249.185 258.556 246.268 260.246 245.969 260.426C245.595 260.65 245.445 260.725 245.445 261.024Z",
    fill: "#7367F0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M281.947 239.931C281.947 240.17 282.296 240.43 282.47 240.529L287.183 243.222C287.557 243.447 287.781 243.521 288.155 243.521C288.514 243.521 288.828 243.372 289.127 243.222L293.69 240.604C294.049 240.365 294.214 240.23 294.214 240.006C294.214 239.707 294.064 239.557 293.69 239.333L289.127 236.715C288.768 236.475 288.379 236.416 288.08 236.416C287.721 236.416 287.343 236.504 287.108 236.64C285.687 237.463 282.77 239.153 282.47 239.333C282.096 239.557 281.947 239.632 281.947 239.931Z",
    fill: "#7367F0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M290.923 245.167C290.923 245.406 291.272 245.666 291.446 245.766L296.159 248.458C296.533 248.683 296.757 248.757 297.131 248.757C297.49 248.757 297.804 248.608 298.104 248.458L302.666 245.84C303.025 245.601 303.19 245.466 303.19 245.242C303.19 244.943 303.04 244.793 302.666 244.569L298.104 241.951C297.744 241.711 297.356 241.652 297.056 241.652C296.697 241.652 296.319 241.74 296.084 241.876C294.663 242.699 291.746 244.389 291.446 244.569C291.072 244.793 290.923 244.868 290.923 245.167Z",
    fill: "#7367F0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M300.048 250.403C300.048 250.643 300.397 250.902 300.571 251.002L305.284 253.694C305.658 253.919 305.882 253.994 306.256 253.994C306.615 253.994 306.929 253.844 307.229 253.694L311.791 251.076C312.15 250.837 312.315 250.702 312.315 250.478C312.315 250.179 312.165 250.029 311.791 249.805L307.229 247.187C306.869 246.948 306.481 246.888 306.181 246.888C305.822 246.888 305.444 246.976 305.209 247.112C303.788 247.935 300.871 249.625 300.571 249.805C300.197 250.029 300.048 250.104 300.048 250.403Z",
    fill: "#7367F0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M320.992 262.52C320.992 262.76 321.341 263.019 321.515 263.119L326.228 265.812C326.602 266.036 326.826 266.111 327.2 266.111C327.559 266.111 327.873 265.961 328.172 265.812L332.735 263.194C333.094 262.954 333.259 262.82 333.259 262.595C333.259 262.296 333.109 262.146 332.735 261.922L328.172 259.304C327.813 259.065 327.424 259.005 327.125 259.005C326.766 259.005 326.387 259.093 326.153 259.229C324.732 260.052 321.814 261.743 321.515 261.922C321.141 262.146 320.992 262.221 320.992 262.52Z",
    fill: "#7367F0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M330.117 267.756C330.117 267.996 330.466 268.255 330.641 268.355L335.353 271.047C335.727 271.272 335.951 271.347 336.325 271.347C336.684 271.347 336.999 271.197 337.298 271.047L341.861 268.429C342.22 268.19 342.384 268.055 342.384 267.831C342.384 267.532 342.235 267.382 341.861 267.158L337.298 264.54C336.939 264.301 336.55 264.241 336.251 264.241C335.892 264.241 335.513 264.329 335.278 264.465C333.857 265.288 330.94 266.978 330.641 267.158C330.267 267.382 330.117 267.457 330.117 267.756Z",
    fill: "#7367F0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M339.243 272.992C339.243 273.231 339.592 273.491 339.766 273.59L344.479 276.283C344.853 276.507 345.077 276.582 345.451 276.582C345.81 276.582 346.124 276.433 346.423 276.283L350.986 273.665C351.345 273.426 351.51 273.291 351.51 273.067C351.51 272.767 351.36 272.618 350.986 272.393L346.423 269.776C346.064 269.536 345.675 269.476 345.376 269.476C345.017 269.476 344.638 269.565 344.404 269.701C342.983 270.523 340.065 272.214 339.766 272.393C339.392 272.618 339.243 272.693 339.243 272.992Z",
    fill: "#7367F0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M348.368 278.228C348.368 278.467 348.717 278.727 348.891 278.826L353.604 281.519C353.978 281.743 354.202 281.818 354.576 281.818C354.935 281.818 355.249 281.669 355.548 281.519L360.111 278.901C360.47 278.662 360.635 278.527 360.635 278.303C360.635 278.004 360.485 277.854 360.111 277.63L355.548 275.012C355.189 274.772 354.8 274.712 354.501 274.712C354.142 274.712 353.763 274.801 353.529 274.937C352.108 275.76 349.19 277.45 348.891 277.63C348.517 277.854 348.368 277.929 348.368 278.228Z",
    fill: "#7367F0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M369.162 290.495C369.162 290.734 369.511 290.993 369.686 291.093L374.398 293.786C374.772 294.01 374.996 294.085 375.37 294.085C375.729 294.085 376.044 293.936 376.343 293.786L380.905 291.168C381.265 290.929 381.429 290.794 381.429 290.57C381.429 290.27 381.279 290.121 380.905 289.896L376.343 287.278C375.984 287.039 375.595 286.979 375.296 286.979C374.937 286.979 374.558 287.068 374.323 287.204C372.902 288.026 369.985 289.717 369.686 289.896C369.312 290.121 369.162 290.196 369.162 290.495Z",
    fill: "#7367F0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M378.288 295.581C378.288 295.821 378.637 296.08 378.811 296.18L383.523 298.872C383.897 299.097 384.122 299.172 384.496 299.172C384.855 299.172 385.169 299.022 385.468 298.872L390.031 296.254C390.39 296.015 390.555 295.88 390.555 295.656C390.555 295.357 390.405 295.207 390.031 294.983L385.468 292.365C385.109 292.126 384.72 292.066 384.421 292.066C384.062 292.066 383.683 292.154 383.449 292.29C382.028 293.113 379.11 294.803 378.811 294.983C378.437 295.207 378.288 295.282 378.288 295.581Z",
    fill: "#7367F0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M387.413 300.817C387.413 301.056 387.762 301.316 387.936 301.415L392.648 304.108C393.022 304.333 393.247 304.407 393.621 304.407C393.98 304.407 394.294 304.258 394.593 304.108L399.156 301.49C399.515 301.251 399.68 301.116 399.68 300.892C399.68 300.593 399.53 300.443 399.156 300.219L394.593 297.601C394.234 297.361 393.845 297.302 393.546 297.302C393.187 297.302 392.808 297.39 392.574 297.526C391.153 298.349 388.235 300.039 387.936 300.219C387.562 300.443 387.413 300.518 387.413 300.817Z",
    fill: "#7367F0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M396.539 306.053C396.539 306.292 396.888 306.552 397.062 306.652L401.774 309.344C402.148 309.569 402.373 309.643 402.747 309.643C403.106 309.643 403.42 309.494 403.719 309.344L408.282 306.726C408.641 306.487 408.806 306.352 408.806 306.128C408.806 305.829 408.656 305.679 408.282 305.455L403.719 302.837C403.36 302.597 402.971 302.538 402.672 302.538C402.313 302.538 401.934 302.626 401.7 302.762C400.279 303.585 397.361 305.275 397.062 305.455C396.688 305.679 396.539 305.754 396.539 306.053Z",
    fill: "#7367F0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M413.144 315.777C413.144 316.016 413.493 316.275 413.667 316.375L418.379 319.068C418.753 319.292 418.978 319.367 419.352 319.367C419.711 319.367 420.025 319.217 420.324 319.068L424.887 316.45C425.246 316.211 425.411 316.076 425.411 315.852C425.411 315.552 425.261 315.403 424.887 315.178L420.324 312.56C419.965 312.321 419.576 312.261 419.277 312.261C418.918 312.261 418.539 312.35 418.305 312.486C416.883 313.308 413.966 314.999 413.667 315.178C413.293 315.403 413.144 315.478 413.144 315.777Z",
    fill: "#7367F0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M254.87 266.859C254.87 267.098 255.219 267.357 255.394 267.457L260.106 270.15C260.48 270.374 260.704 270.449 261.078 270.449C261.437 270.449 261.752 270.299 262.051 270.15L266.613 267.532C266.973 267.292 267.137 267.158 267.137 266.933C267.137 266.634 266.987 266.485 266.613 266.26L262.051 263.642C261.692 263.403 261.303 263.343 261.004 263.343C260.645 263.343 260.266 263.432 260.031 263.567C258.61 264.39 255.693 266.081 255.394 266.26C255.02 266.485 254.87 266.559 254.87 266.859Z",
    fill: "#7367F0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M246.343 271.795C246.343 272.035 246.692 272.294 246.866 272.394L251.579 275.086C251.953 275.311 252.177 275.386 252.551 275.386C252.91 275.386 253.224 275.236 253.523 275.086L258.086 272.469C258.445 272.229 258.61 272.095 258.61 271.87C258.61 271.571 258.46 271.421 258.086 271.197L253.523 268.579C253.164 268.34 252.775 268.28 252.476 268.28C252.117 268.28 251.739 268.368 251.504 268.504C250.083 269.327 247.166 271.017 246.866 271.197C246.492 271.421 246.343 271.496 246.343 271.795Z",
    fill: "#7367F0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M255.917 277.33C255.917 277.57 256.266 277.829 256.441 277.929L261.153 280.621C261.527 280.846 261.751 280.921 262.125 280.921C262.484 280.921 262.798 280.771 263.098 280.621L267.66 278.003C268.019 277.764 268.184 277.629 268.184 277.405C268.184 277.106 268.034 276.956 267.66 276.732L263.098 274.114C262.739 273.875 262.35 273.815 262.05 273.815C261.691 273.815 261.313 273.903 261.078 274.039C259.657 274.862 256.74 276.552 256.441 276.732C256.067 276.956 255.917 277.031 255.917 277.33Z",
    fill: "#7367F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M265.341 282.716C265.341 282.955 265.69 283.215 265.865 283.314L274.916 288.55C275.29 288.775 275.514 288.849 275.888 288.849C276.247 288.849 276.561 288.7 276.86 288.55L281.423 285.932C281.782 285.693 281.947 285.558 281.947 285.334C281.947 285.035 281.797 284.885 281.423 284.661L272.522 279.5C272.163 279.26 271.774 279.2 271.475 279.2C271.116 279.2 270.737 279.289 270.502 279.425C269.081 280.248 266.164 281.938 265.865 282.118C265.491 282.342 265.341 282.417 265.341 282.716Z",
    fill: "#7367F0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M279.404 290.944C279.404 291.183 279.753 291.442 279.927 291.542L288.978 296.778C289.352 297.002 289.576 297.077 289.95 297.077C290.309 297.077 290.624 296.927 290.923 296.778L295.485 294.16C295.845 293.92 296.009 293.786 296.009 293.561C296.009 293.262 295.859 293.113 295.485 292.888L286.584 287.727C286.225 287.488 285.836 287.428 285.537 287.428C285.178 287.428 284.8 287.517 284.565 287.652C283.144 288.475 280.227 290.166 279.927 290.345C279.553 290.57 279.404 290.644 279.404 290.944Z",
    fill: "#7367F0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M349.714 331.484C349.714 331.724 350.063 331.983 350.237 332.083L359.288 337.319C359.662 337.543 359.886 337.618 360.26 337.618C360.619 337.618 360.934 337.468 361.233 337.319L365.796 334.701C366.155 334.461 366.319 334.327 366.319 334.102C366.319 333.803 366.17 333.653 365.796 333.429L356.895 328.268C356.535 328.029 356.147 327.969 355.847 327.969C355.488 327.969 355.11 328.057 354.875 328.193C353.454 329.016 350.537 330.706 350.237 330.886C349.863 331.11 349.714 331.185 349.714 331.484Z",
    fill: "#7367F0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M363.776 339.563C363.776 339.802 364.125 340.061 364.3 340.161L373.351 345.397C373.725 345.621 373.949 345.696 374.323 345.696C374.682 345.696 374.996 345.547 375.295 345.397L379.858 342.779C380.217 342.54 380.382 342.405 380.382 342.181C380.382 341.881 380.232 341.732 379.858 341.507L370.957 336.346C370.598 336.107 370.209 336.047 369.91 336.047C369.551 336.047 369.172 336.136 368.937 336.272C367.516 337.094 364.599 338.785 364.3 338.964C363.926 339.189 363.776 339.263 363.776 339.563Z",
    fill: "#7367F0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M293.765 299.172C293.765 299.411 294.114 299.67 294.289 299.77L345.451 329.241C345.825 329.465 346.049 329.54 346.423 329.54C346.782 329.54 347.096 329.39 347.396 329.241L351.958 326.623C352.317 326.383 352.482 326.249 352.482 326.024C352.482 325.725 352.332 325.575 351.958 325.351L300.946 295.955C300.587 295.716 300.198 295.656 299.899 295.656C299.54 295.656 299.161 295.745 298.926 295.88C297.505 296.703 294.588 298.394 294.289 298.573C293.915 298.798 293.765 298.872 293.765 299.172Z",
    fill: "#7367F0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M264.444 272.393C264.444 272.633 264.793 272.892 264.967 272.992L381.952 340.46C382.326 340.685 382.551 340.759 382.925 340.759C383.284 340.759 383.598 340.61 383.897 340.46L388.46 337.842C388.819 337.603 388.983 337.468 388.983 337.244C388.983 336.945 388.834 336.795 388.46 336.571L271.625 269.177C271.265 268.938 270.877 268.878 270.577 268.878C270.218 268.878 269.84 268.966 269.605 269.102C268.184 269.925 265.267 271.616 264.967 271.795C264.593 272.019 264.444 272.094 264.444 272.393Z",
    fill: "#7367F0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M264.444 272.393C264.444 272.633 264.793 272.892 264.967 272.992L381.952 340.46C382.326 340.685 382.551 340.759 382.925 340.759C383.284 340.759 383.598 340.61 383.897 340.46L388.46 337.842C388.819 337.603 388.983 337.468 388.983 337.244C388.983 336.945 388.834 336.795 388.46 336.571L271.625 269.177C271.265 268.938 270.877 268.878 270.577 268.878C270.218 268.878 269.84 268.966 269.605 269.102C268.184 269.925 265.267 271.616 264.967 271.795C264.593 272.019 264.444 272.094 264.444 272.393Z",
    fill: "#7367F0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M254.196 255.938C254.196 256.177 254.545 256.437 254.72 256.536L391.078 335.224C391.452 335.449 391.676 335.524 392.05 335.524C392.409 335.524 392.723 335.374 393.022 335.224L397.585 332.606C397.944 332.367 398.109 332.232 398.109 332.008C398.109 331.709 397.959 331.559 397.585 331.335L261.377 252.722C261.018 252.482 260.629 252.422 260.33 252.422C259.971 252.422 259.592 252.511 259.357 252.647C257.936 253.47 255.019 255.16 254.72 255.34C254.346 255.564 254.196 255.639 254.196 255.938Z",
    fill: "#7367F0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M263.247 250.552C263.247 250.792 263.596 251.051 263.771 251.151L400.128 329.839C400.502 330.063 400.727 330.138 401.101 330.138C401.46 330.138 401.774 329.988 402.073 329.839L406.636 327.221C406.995 326.981 407.159 326.847 407.159 326.622C407.159 326.323 407.01 326.173 406.636 325.949L270.428 247.336C270.069 247.096 269.68 247.037 269.381 247.037C269.022 247.037 268.643 247.125 268.408 247.261C266.987 248.084 264.07 249.774 263.771 249.954C263.397 250.178 263.247 250.253 263.247 250.552Z",
    fill: "#7367F0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M272.447 245.466C272.447 245.705 272.796 245.965 272.971 246.064L409.329 324.752C409.703 324.977 409.927 325.052 410.301 325.052C410.66 325.052 410.974 324.902 411.273 324.752L415.836 322.134C416.195 321.895 416.36 321.76 416.36 321.536C416.36 321.237 416.21 321.087 415.836 320.863L279.628 242.25C279.269 242.01 278.88 241.95 278.581 241.95C278.222 241.95 277.843 242.039 277.608 242.175C276.187 242.998 273.27 244.688 272.971 244.868C272.597 245.092 272.447 245.167 272.447 245.466Z",
    fill: "#7367F0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.091 319.666C227.418 319.218 226.745 318.529 226.745 317.572C226.745 316.674 227.418 316.076 228.091 315.702L261.825 296.254C262.483 295.836 263.321 295.656 264.293 295.656C265.565 295.656 266.837 296.03 267.659 296.554L319.42 326.398C320.437 326.997 320.692 327.685 320.692 328.343C320.692 329.001 320.093 329.764 319.495 330.138L285.536 349.735C284.818 350.154 283.891 350.259 283.068 350.259C282.17 350.259 280.974 350.184 280.226 349.735L228.091 319.666ZM228.69 318.993C228.091 318.619 227.568 318.096 227.568 317.572C227.568 317.123 227.852 316.779 228.69 316.301L262.424 296.928C262.947 296.629 263.591 296.554 264.368 296.554C265.191 296.554 266.059 296.584 266.837 297.003L318.672 326.997C319.345 327.371 319.794 327.82 319.794 328.343C319.794 328.867 319.286 329.241 318.747 329.54L284.938 349.062C284.414 349.362 283.532 349.436 282.993 349.436C282.455 349.436 281.243 349.302 280.824 349.062L228.69 318.993Z",
    fill: "#7367F0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M154.414 281.744C153.397 282.402 153.143 282.866 153.143 283.464C153.143 284.137 153.651 284.721 154.489 285.259L219.19 322.68L472.607 317.017L286.733 209.414C285.476 208.695 284.564 208.441 283.217 208.441C281.721 208.441 280.524 208.89 279.702 209.414L154.414 281.744Z",
    fill: "#A9A2F6",
    fillOpacity: 0.3
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M161.521 276.807C161.521 277.525 162.119 278.228 162.942 278.752L297.729 356.692L292.717 202.308C292.642 201.934 292.044 201.859 291.146 201.859C289.725 201.859 288.977 202.233 288.08 202.756L162.493 275.236C161.67 275.76 161.52 276.358 161.521 276.807Z",
    fill: "url(#paint33_linear_1049_5707)",
    fillOpacity: 0.25
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M305.731 65.5009L301.692 67.9693L478.067 318.544L482.48 316.076C483.826 315.253 484.296 314.356 484.5 313.009C484.978 309.838 500.132 180.616 500.132 178.746C500.132 176.128 498.936 174.856 497.14 173.809L309.546 65.5009C308.947 65.2018 308.424 65.127 307.676 65.127C306.928 65.127 306.255 65.2018 305.731 65.5009Z",
    fill: "url(#paint34_linear_1049_5707)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1049_5707",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 65,
    width: 200,
    height: 254
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M305.731 65.5009L301.692 67.9693L478.067 318.544L482.48 316.076C483.826 315.253 484.296 314.356 484.5 313.009C484.978 309.838 500.132 180.616 500.132 178.746C500.132 176.128 498.936 174.856 497.14 173.809L309.546 65.5009C308.947 65.2018 308.424 65.127 307.676 65.127C306.928 65.127 306.255 65.2018 305.731 65.5009Z",
    fill: "url(#paint35_linear_1049_5707)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1049_5707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.086 175.006L495.57 177.1L496.468 179.718L500.432 177.474L499.086 175.006Z",
    fill: "url(#paint36_linear_1049_5707)"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M306.18 68.2687C305.103 67.6703 304.46 67.5208 303.562 67.5208C302.619 67.5208 301.885 67.7763 301.328 68.2096C301.3 68.2319 301.272 68.2546 301.243 68.2776C301.271 68.2545 301.299 68.2318 301.328 68.2096C302.593 67.1954 303.359 66.9224 304.31 66.9224C305.088 66.9224 305.956 67.072 306.704 67.5208L493.775 175.605C495.72 176.727 496.916 177.849 496.916 180.541C496.916 181.738 486.544 270.449 481.358 314.655C481.119 316.69 479.488 318.096 478.366 318.395C479.503 317.916 480.236 316.45 480.461 314.88L496.094 180.541C496.273 178.567 495.046 177.325 493.775 176.652L306.18 68.2687Z",
    fill: "#7367F0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M299.897 71.1859L284.414 203.804C284.04 206.646 284.624 208.232 287.256 209.788L474.552 318.245C475.524 318.769 477.32 319.011 478.367 318.395C479.638 317.647 480.237 316.45 480.461 314.88L496.094 180.541C496.273 178.567 495.047 177.325 493.775 176.652L306.18 68.2687C305.103 67.6703 304.46 67.5208 303.562 67.5208C302.571 67.5208 301.81 67.8032 301.244 68.2776C300.443 68.9483 300.029 70.003 299.897 71.1859Z",
    fill: "url(#paint37_linear_1049_5707)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.034 154.916C353.407 151.686 353.816 148.132 353.902 147.704C354.052 146.956 354.725 146.657 355.174 146.657C355.473 146.657 355.622 146.732 355.996 146.956C356.296 147.136 401.449 173.211 423.988 186.226C424.765 186.674 425.335 187.273 425.26 188.619C425.127 191.009 424.243 198.044 424.063 199.241C423.94 200.063 423.539 200.512 422.866 200.512C422.432 200.512 422.095 200.302 421.639 200.017L421.595 199.989L353.827 160.869C353.154 160.495 352.496 159.538 352.63 158.401C352.744 157.435 352.886 156.201 353.034 154.916ZM354.126 160.196C353.802 160.021 353.184 159.448 353.304 158.55C353.423 157.653 354.201 151.095 354.575 147.929C354.611 147.63 354.8 147.405 355.099 147.405C355.282 147.405 355.436 147.495 355.715 147.659C355.777 147.696 355.845 147.736 355.922 147.779L423.465 186.749C424.063 187.048 424.661 187.722 424.587 188.544L423.315 199.241C423.24 199.615 423.106 199.764 422.866 199.764C422.642 199.764 422.567 199.719 422.268 199.54L354.126 160.196Z",
    fill: "#7367F0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.583 174.663C350.955 171.433 351.365 167.88 351.45 167.451C351.6 166.703 352.273 166.404 352.722 166.404C353.021 166.404 353.171 166.479 353.545 166.703C353.844 166.883 398.997 192.958 421.537 205.973C422.314 206.422 422.883 207.02 422.808 208.366C422.675 210.756 421.791 217.791 421.611 218.988C421.488 219.81 421.088 220.259 420.415 220.259C419.98 220.259 419.643 220.049 419.188 219.764L419.143 219.736L351.376 180.616C350.702 180.242 350.044 179.285 350.179 178.148C350.292 177.182 350.435 175.948 350.583 174.663ZM351.675 179.943C351.351 179.768 350.732 179.195 350.852 178.297C350.972 177.4 351.75 170.842 352.124 167.676C352.159 167.377 352.348 167.152 352.647 167.152C352.831 167.152 352.984 167.242 353.264 167.406C353.326 167.443 353.394 167.483 353.47 167.526L421.013 206.496C421.611 206.795 422.21 207.469 422.135 208.291L420.863 218.988C420.789 219.362 420.654 219.511 420.415 219.511C420.19 219.511 420.115 219.466 419.816 219.287L351.675 179.943Z",
    fill: "#7367F0"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.029,
    cy: 192.895,
    rx: 1.49256,
    ry: 2.09582,
    transform: "rotate(-30 385.029 192.895)",
    fill: "#7367F0"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.2,
    cy: 195.893,
    rx: 1.49256,
    ry: 2.09582,
    transform: "rotate(-30 390.2 195.893)",
    fill: "#7367F0"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.286,
    cy: 198.735,
    rx: 1.49256,
    ry: 2.09582,
    transform: "rotate(-30 395.286 198.735)",
    fill: "#7367F0"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.373,
    cy: 201.727,
    rx: 1.49256,
    ry: 2.09582,
    transform: "rotate(-30 400.373 201.727)",
    fill: "#7367F0"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.609,
    cy: 204.719,
    rx: 1.49256,
    ry: 2.09582,
    transform: "rotate(-30 405.609 204.719)",
    fill: "#7367F0"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.695,
    cy: 207.711,
    rx: 1.49256,
    ry: 2.09582,
    transform: "rotate(-30 410.695 207.711)",
    fill: "#7367F0"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.781,
    cy: 210.703,
    rx: 1.49256,
    ry: 2.09582,
    transform: "rotate(-30 415.781 210.703)",
    fill: "#7367F0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M349.414 187.647L348.142 198.044C347.993 199.241 348.56 199.914 349.339 200.363C371.504 213.128 415.82 238.749 416.358 239.108C417.144 239.632 417.705 239.856 418.004 239.856C418.303 239.856 418.827 239.632 418.976 238.66C419.096 237.882 419.824 231.454 420.173 228.337C420.173 227.141 419.65 226.617 418.528 225.944L351.583 187.273C350.91 186.899 350.685 186.75 350.311 186.75C349.788 186.75 349.489 187.198 349.414 187.647Z",
    fill: "#7367F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1049_5707",
    x1: 105.916,
    y1: 159.762,
    x2: 208.173,
    y2: 159.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DDDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1049_5707",
    x1: 104.588,
    y1: 166.347,
    x2: 208.173,
    y2: 166.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A199F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506239,
    stopColor: "#A9A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D94F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1049_5707",
    x1: 104.588,
    y1: 145.276,
    x2: 208.173,
    y2: 145.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A199F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506239,
    stopColor: "#A9A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D94F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1049_5707",
    x1: 105.915,
    y1: 139.548,
    x2: 208.007,
    y2: 139.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DDDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1049_5707",
    x1: 360.001,
    y1: 465.095,
    x2: 464.998,
    y2: 465.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DDDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1049_5707",
    x1: 358.637,
    y1: 471.857,
    x2: 464.998,
    y2: 471.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A199F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506239,
    stopColor: "#A9A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D94F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1049_5707",
    x1: 358.637,
    y1: 450.221,
    x2: 464.998,
    y2: 450.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A199F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506239,
    stopColor: "#A9A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D94F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1049_5707",
    x1: 360,
    y1: 444.34,
    x2: 464.827,
    y2: 444.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DDDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1049_5707",
    x1: 506.511,
    y1: 223.143,
    x2: 665.312,
    y2: 223.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A199F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506239,
    stopColor: "#A9A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D94F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1049_5707",
    x1: 508.547,
    y1: 227.531,
    x2: 665.312,
    y2: 227.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DDDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1049_5707",
    x1: 528.561,
    y1: 65.8998,
    x2: 532.048,
    y2: 72.1062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CCC7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1049_5707",
    x1: 529.076,
    y1: 66.2648,
    x2: 529.076,
    y2: 73.2441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9D94F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1049_5707",
    x1: 579.778,
    y1: 97.4203,
    x2: 583.264,
    y2: 103.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CCC7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1049_5707",
    x1: 580.293,
    y1: 97.786,
    x2: 580.293,
    y2: 104.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9D94F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1049_5707",
    x1: 579.918,
    y1: 218.76,
    x2: 583.405,
    y2: 224.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CCC7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1049_5707",
    x1: 580.432,
    y1: 219.125,
    x2: 580.432,
    y2: 226.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9D94F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1049_5707",
    x1: 528.593,
    y1: 187.239,
    x2: 532.08,
    y2: 193.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CCC7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1049_5707",
    x1: 529.107,
    y1: 187.605,
    x2: 529.107,
    y2: 194.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9D94F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1049_5707",
    x1: 654.5,
    y1: 224.5,
    x2: 587,
    y2: 93.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1049_5707",
    x1: 525.702,
    y1: 60.3854,
    x2: 648.088,
    y2: 60.3854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0368126,
    stopColor: "#DDDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D0CCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2ABF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1049_5707",
    x1: 586.93,
    y1: 59.0655,
    x2: 525.702,
    y2: 59.0655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A9A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522444,
    stopColor: "#9890F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1049_5707",
    x1: 586.93,
    y1: 84.9373,
    x2: 542.578,
    y2: 59.4141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7266F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8378F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1049_5707",
    x1: 631.281,
    y1: 59.4141,
    x2: 586.93,
    y2: 84.9373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D9D5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1049_5707",
    x1: 542.578,
    y1: 57.5313,
    x2: 631.282,
    y2: 57.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D0CCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500126,
    stopColor: "#EEECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586458,
    stopColor: "#EEECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1049_5707",
    x1: 579.12,
    y1: 63.4128,
    x2: 598.19,
    y2: 52.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1049_5707",
    x1: 598.227,
    y1: 52.3715,
    x2: 600.808,
    y2: 53.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1049_5707",
    x1: 573.192,
    y1: 59.9257,
    x2: 592.262,
    y2: 48.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1049_5707",
    x1: 592.299,
    y1: 48.8847,
    x2: 594.88,
    y2: 50.3489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1049_5707",
    x1: 567.264,
    y1: 56.5783,
    x2: 586.334,
    y2: 45.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1049_5707",
    x1: 586.371,
    y1: 45.5373,
    x2: 588.952,
    y2: 47.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1049_5707",
    x1: 604.224,
    y1: 55.7882,
    x2: 606.804,
    y2: 57.2527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1049_5707",
    x1: 585.117,
    y1: 66.8762,
    x2: 604.224,
    y2: 55.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B2ABF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1049_5707",
    x1: 153,
    y1: 290,
    x2: 477.319,
    y2: 302.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A199F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C3BEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A199F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1049_5707",
    x1: 256.589,
    y1: 201.859,
    x2: 262.125,
    y2: 356.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5445ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F0",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1049_5707",
    x1: 305.581,
    y1: 61.9854,
    x2: 481.358,
    y2: 319.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2917E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610964,
    stopColor: "#6558EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2917E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1049_5707",
    x1: 305.581,
    y1: 61.9854,
    x2: 481.358,
    y2: 319.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610964,
    stopColor: "#44CB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BA861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1049_5707",
    x1: 499.759,
    y1: 176.053,
    x2: 496.318,
    y2: 178.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7F74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#877DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1049_5707",
    x1: 496,
    y1: 241.5,
    x2: 284,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DDDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BEF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/login-img.d6606c8246e0c42705a8c31c7b0df3a8.svg";
export { ForwardRef as ReactComponent };